var render, staticRenderFns
import script from "./WeightChart.vue?vue&type=script&lang=js&"
export * from "./WeightChart.vue?vue&type=script&lang=js&"
import style0 from "./WeightChart.vue?vue&type=style&index=0&id=1af81cc6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports